import { useMutation, useQueryClient } from '@tanstack/react-query';

import { GET_TAXONOMIES_BY_VERSION_QUERY_KEY } from './useGetTaxonomiesByVersion';
import { GET_TAXONOMIES_VERSIONS_QUERY_KEY } from './useGetTaxonomiesVersions';
import { GET_TAXONOMIES_BY_VERSION_AND_CATEGORY_QUERY_KEY } from './useGetTaxonomyPropertiesByVersionAndCategory';

import TaxonomiesService, {
  TaxonomiesUpdatedResponse,
} from '@/services/TaxonomiesService';

export function useUpdateTaxonomy(onSuccess?: () => void) {
  const queryClient = useQueryClient();
  const { mutateAsync, isPending } = useMutation({
    mutationFn: (taxonomiesUpdatedResponse: TaxonomiesUpdatedResponse) =>
      TaxonomiesService.updateTaxonomiesByVersion(taxonomiesUpdatedResponse),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: GET_TAXONOMIES_BY_VERSION_AND_CATEGORY_QUERY_KEY,
      });
      queryClient.invalidateQueries({
        queryKey: GET_TAXONOMIES_BY_VERSION_QUERY_KEY,
      });
      queryClient.invalidateQueries({
        queryKey: GET_TAXONOMIES_VERSIONS_QUERY_KEY,
      });
      if (onSuccess) onSuccess();
    },
  });

  return {
    updateTaxonomy: mutateAsync,
    isLoading: isPending,
  };
}
